// extracted by mini-css-extract-plugin
export default {"wrapper":"ScreenCanvas_wrapper__9OBGm","textField":"ScreenCanvas_textField__Ypzhu","image":"ScreenCanvas_image__5HoYc","canvasWrapper":"ScreenCanvas_canvasWrapper__Nwj-T"};